var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPattern(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 87,
    viewBox: "0 0 266 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_839_1860)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 265,
    height: 86.7,
    rx: 4,
    transform: "matrix(-1 0 0 1 265.5 0.150024)",
    fill: "#427A5B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-480.83 331.115L831.143 -4652.05H492.336L-819.637 331.115H-480.83Z",
    fill: "#FFCA66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-894.815 3468.79L417.158 -1514.38H78.352L-1233.62 3468.79H-894.815Z",
    fill: "#B4CD93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-220.517 1896.44L423.307 -553.196H257.045L-386.779 1896.44H-220.517Z",
    fill: "#FF896B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-50.5222 471.318L359.773 -1088.1H253.818L-156.478 471.318H-50.5222Z",
    fill: "#FFCA66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.832 845.099L386.416 -169.953H317.315L49.7305 845.099H118.832Z",
    fill: "#FFCA66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-310.924 601.929L199.918 -1340.18H67.9971L-442.845 601.929H-310.924Z",
    fill: "#FF896B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.124 335.503L740.967 -1606.6H609.046L98.2036 335.503H230.124Z",
    fill: "#B4CD93"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_839_1860"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 265,
    height: 86.7,
    rx: 4,
    transform: "matrix(-1 0 0 1 265.5 0.150024)",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPattern);
export default __webpack_public_path__ + "static/media/pattern.40feec63c73a4864a0504b3b5d2b3170.svg";
export { ForwardRef as ReactComponent };